import { type SlugifyOptions, slugify } from '@florezjaramillo/florezjaramillo-core'

export { type SlugifyOptions, slugify }

export type SlugifyOptionsType = SlugifyOptions

/** @deprecated Usa `slugify`. Se mantiene porque este paquete se publica. */
export const generateSlug = (text: string): string => slugify(text)
